<div class="modal">
  <div class="container container-expand expand" (mouseup)="zoomMouseDown = false">
    <div class="row ">
      <div class="col-sm-8 col-xs-5"></div>
      <div class="col-sm-4 col-xs-7">
        <div class="icon-container icon-expand">
          <div class="icon">
            <img (click)="zoomIn()" src="assets/img-svg/zoom_in_white_24dp.svg" alt="">
          </div>
          <div class="icon">
            <img (click)="zoomOut()" src="assets/img-svg/zoom_out_white_24dp.svg" alt="">
          </div>
          <a *ngIf="!!currentDetalle" class="icon" [href]="getDownloadPath(currentDetalle.IMAGENURL)" download>
            <img src="assets/img-svg/file_download_white_24dp.svg" alt="">
          </a>
          <div class="icon" (click)="back()">
            <img src="assets/img-svg/cancel_white_24dp.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="row row-expand">
      <div class="col-md-12 col-sm-12 col-xs-12 expand-ipad " *ngIf="!!currentDetalle">
        <div class="title-detail">
          <span>{{getNombreMaterial(currentDetalle.MATERIAL)}} {{language.BLOQUE_TEXT}} {{currentDetalle.BLOQUE}}</span>
          <br/>
          <span *ngIf="!groupByBundle">{{language.SLAB_NUMBER_TITLE}} {{currentDetalle.ID}} ({{currentDetalleIndex + 1}}/{{detalles.length}})</span>
          <span *ngIf="groupByBundle">{{language.PAQUETE_TITLE}} {{currentDetalle.GRUPO || 'N/A'}} ({{currentDetalleIndex + 1}}/{{detalles.length}})</span>
          <br/>
          <span *ngIf="!groupByBundle">{{getAcabadoMaterial(currentDetalle.ACABADO)}} {{getMedida(currentDetalle.LARGO)}} 
            x {{getMedida(currentDetalle.ALTO)}} x {{getEspesor(currentDetalle.ANCHO)}} </span>
        </div>
        <gallery (indexChange)="galleryIndexChange($event)" [items]="imgs" [gestures]="false" [counter]="false"
          [itemTemplate]="itemTemplate" [thumb]="false" class="zoom"></gallery>
      </div>
      <!-- <div class="col-md-2 col-sm-12 col-xs-12 expand-ipad column-table" *ngIf="!!currentDetalle">
        <table class="table-detail">
          <tr class="padding">
            <td class="name-description">
              <span>{{language.TIPO_MATERIAL_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getNombreTipoMaterial(currentDetalle.MATERIAL)}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.ACBABADO_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getAcabadoMaterial(currentDetalle.ACABADO)}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.ANCHO_MATERIAL_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getEspesor(currentDetalle.ANCHO)}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.ALTO_MATERIAL_TITLE}}</span>
            </td>
            <td class="description" *ngIf="!!currentDetalle">
              <span>{{getMedida(currentDetalle.ALTO) + getUnidadLanguage()}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.LARGO_MATERIAL_TITLE}}</span>
            </td>
            <td class="description" *ngIf="!!currentDetalle">
              <span>{{getMedida(currentDetalle.LARGO) + getUnidadLanguage()}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.DISPONIBILIDAD_FILTER_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getDisponibilidad(currentDetalle.DISPONIBILIDAD)}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.COLOR_MATERIAL_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getColorMaterial(currentDetalle.MATERIAL)}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td>
              <span>{{language.PIEZAS_DELTALLE_TITLE}}</span>
            </td>
            <td class="description">
              <span>{{getPiezas(currentDetalle.PIEZAS)}}</span>
            </td>
          </tr>
          <tr class="padding">
            <td class="table-details">
              <span>{{language.NUMERO_LOTE}}</span>
            </td>
            <td class="table-details">
              <span>{{currentDetalle.ID}}</span>
            </td>
          </tr>
        </table>
      </div> -->
    </div>
  </div>
  <br>
  <br>
  <br>
</div>


<ng-template #itemTemplate let-index="index" let-type="type" let-data="data" let-currIndex="currIndex">
  <ng-container *ngIf="index === currIndex">
    <pinch-zoom [backgroundColor]="'#111'" [overflow]="'visible'" (touchend)="tgglGesture()">
      <img [src]="currentDetalle.IMAGENURL">
    </pinch-zoom>
  </ng-container>
</ng-template>

